import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from '../../_services/loading.service';
import { EbayService } from '../_shemistshopservices/ebay.service';
import {SelectionModel} from '@angular/cdk/collections';
import { NotificationService } from 'src/app/_services/notification.service';

@Component({
  selector: 'app-ebay-orders',
  templateUrl: './ebay-orders.component.html',
  styleUrls: ['./ebay-orders.component.css']
})
export class EbayOrdersComponent implements OnInit {

  orderStatusList: any = [];
  selectedStatus: any = null;
  itemSelection = new SelectionModel<any>(true, []);
  allOrders: any = [];
  qadisplayedColumns: string[] = ['select','OrderNumber', 'RoyalMailTracking', 'OrderDate', 'qa_status', 'FirstName', 
    'ItemName', 'Quantity', 'Postcode', 'Status'];

  displayedColumns: string[] = ['OrderNumber', 'RoyalMailTracking', 'OrderDate', 'qa_status', 'FirstName', 
    'ItemName', 'Quantity', 'Postcode', 'Status'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  newOrders: any = [];
  newOrdersdataSource: MatTableDataSource<any>;

  qaReceived: any = [];
  qaReceiveddataSource: MatTableDataSource<any>;

  applyPostage: any = [];
  applyPostagedataSource: MatTableDataSource<any>;

  orderDispatched: any = [];
  orderDispatcheddataSource: MatTableDataSource<any>;

  constructor(
  private titleService: Title,
  private ebayService: EbayService,
  private notificationService: NotificationService,
  private loading : LoadingService) { }


  ngOnInit() {
    this.titleService.setTitle('Order List');
    this.onLoadOrders();
    this.get_ebay_order_status();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.itemSelection.selected.length;
    const numRows = this.qaReceiveddataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.itemSelection.clear() :
        this.qaReceiveddataSource.data.forEach(row => this.itemSelection.select(row));
  }

  onLoadOrders() {
    //console.log('ok');
    var result = this.ebayService.get_ebay_orders().subscribe(data=> {
      console.log(data['data']);
      this.newOrders = data['data'].filter(x=> x.order_status_id === 1);
      this.newOrdersdataSource = new MatTableDataSource<any>(this.newOrders);

      this.qaReceived = data['data'].filter(x=> x.order_status_id === 2);
      this.qaReceiveddataSource = new MatTableDataSource<any>(this.qaReceived);

      this.applyPostage = data['data'].filter(x=> x.order_status_id === 3);
      this.applyPostagedataSource = new MatTableDataSource<any>(this.applyPostage);

      this.orderDispatched = data['data'].filter(x=> x.order_status_id === 4);
      this.orderDispatcheddataSource = new MatTableDataSource<any>(this.orderDispatched);

      //console.log(data['dataList']);
      this.allOrders = data['data'];
      this.dataSource = new MatTableDataSource<any>(this.allOrders);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  onViewOrder(order_id){
    console.log('onViewOrder');
  }  
  
  applyFilter()
  {
    console.log(this.searchKey.trim());
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  get_ebay_order_status(){
    var result = this.ebayService.get_ebay_order_status().subscribe(data=> {
      console.log(data);
      // this.orderData = data['order_data'];
      // this.older_orders = data['older_orders'];
      this.orderStatusList = data['ebay_order_status_list'];
      // console.log(this.orderStatusList);

      // const formData = {
      //   id: this.orderData.id,
      //   order_status_id: this.orderData.order_status_id,
      // };

      // console.log(formData);

      // this.statusForm.setValue(formData);

    });
  }

  onUpdateStatus(){
    if(this.itemSelection.selected.length>0)
    {
      this.loading.spin$.next(true);
      var result = this.ebayService.update_ebay_orders_status(this.itemSelection.selected, this.selectedStatus).subscribe(data=> {
        console.log(data);
        if(JSON.stringify(data['status'])=='true') {
          this.notificationService.success(data['message']);
          this.itemSelection.clear();
          this.onLoadOrders();
          this.loading.spin$.next(false);
        }
        else {
          this.loading.spin$.next(false);
        }        
      });
    }
    else{
      this.notificationService.error(JSON.stringify('Please select orders'));
    }
  }

}

